export const UploadIcon = () => {
  return (
    <svg width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_216_1281)'>
        <path
          d='M12.668 12.667L9.5013 9.50033L6.33464 12.667'
          stroke='#0088CC'
          stroke-width='1.63447'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path d='M9.5 16.625L9.5 9.5' stroke='#0088CC' stroke-width='1.63447' stroke-linecap='round' stroke-linejoin='round' />
        <path
          d='M16.5306 14.3217C17.2189 13.8377 17.735 13.147 18.0041 12.3498C18.2732 11.5525 18.2813 10.6903 18.0272 9.88821C17.773 9.0861 17.2699 8.38584 16.5908 7.88905C15.9117 7.39225 15.092 7.12478 14.2506 7.12544H13.2531C13.015 6.1975 12.5695 5.33567 11.9501 4.60483C11.3307 3.87399 10.5536 3.29318 9.6773 2.90613C8.80097 2.51908 7.84826 2.33587 6.89088 2.3703C5.9335 2.40473 4.99641 2.6559 4.15015 3.1049C3.30389 3.5539 2.57052 4.18902 2.00524 4.96247C1.43996 5.73591 1.0575 6.62751 0.886669 7.57015C0.715835 8.51279 0.761071 9.48191 1.01897 10.4045C1.27687 11.3272 1.74072 12.1793 2.37559 12.8967'
          stroke='#0088CC'
          stroke-width='1.63447'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_216_1281'>
          <rect width='19' height='19' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
